import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
export default (function (InnerComponent, componentType) {
  function isTargetComponent(message) {
    return message.componentType === componentType;
  }
  function computeNewState(state) {
    var current = state.current;
    if (current && isTargetComponent(current)) {
      var message;
      switch (current.componentType) {
        case 'contextualSurvey':
          message = _objectSpread(_objectSpread({}, current), {}, {
            aaid: state.config.aaid,
            cloudId: state.config.cloudId,
            stargateUrl: state.config.stargateUrl,
            product: state.config.product,
            orgId: state.config.orgId,
            workspaceId: state.config.workspaceId
          });
          break;
        default:
          message = current;
      }
      return {
        message: message
      };
    }
    return {
      message: null
    };
  }
  function getComponentType() {
    return componentType;
  }

  // eslint-disable-next-line @repo/internal/react/no-class-components
  var StoreWrapper = /*#__PURE__*/function (_Component) {
    _inherits(StoreWrapper, _Component);
    var _super = _createSuper(StoreWrapper);
    function StoreWrapper() {
      var _this;
      _classCallCheck(this, StoreWrapper);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized(_this), "state", {
        message: null
      });
      _defineProperty(_assertThisInitialized(_this), "onStoreChange", function (state) {
        _this.setState(computeNewState(state));
      });
      return _this;
    }
    _createClass(StoreWrapper, [{
      key: "UNSAFE_componentWillMount",
      value: function UNSAFE_componentWillMount() {
        if (this.canSubscribe()) {
          this.unsubscribe = this.subscribeToStore();
        }
        if (this.canSetConfig()) {
          this.removeConfig = this.setChoreographerConfig();
        }
      }
    }, {
      key: "UNSAFE_componentWillReceiveProps",
      value: function UNSAFE_componentWillReceiveProps(nextProps) {
        var _this$props, _this$props2, _this$props3;
        if (((_this$props = this.props) === null || _this$props === void 0 ? void 0 : _this$props.engagementId) !== (nextProps === null || nextProps === void 0 ? void 0 : nextProps.engagementId) && this.removeConfig && this.canSetConfig()) {
          this.removeConfig();
          this.removeConfig = this.setChoreographerConfig(nextProps);
        } else if ((((_this$props2 = this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.messageType) !== (nextProps === null || nextProps === void 0 ? void 0 : nextProps.messageType) || ((_this$props3 = this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.onMessageDisposition) !== (nextProps === null || nextProps === void 0 ? void 0 : nextProps.onMessageDisposition)) && this.canSetConfig()) {
          this.setChoreographerConfig(nextProps);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (this.unsubscribe) {
          this.unsubscribe();
        }
        if (this.removeConfig) {
          this.removeConfig();
        }
      }
    }, {
      key: "canSetConfig",
      value: function canSetConfig() {
        return this.context && this.context.setComponentConfig;
      }
    }, {
      key: "setChoreographerConfig",
      value: function setChoreographerConfig() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
        return this.context.setComponentConfig(getComponentType(), {
          messageType: props.messageType,
          onMessageDisposition: props.onMessageDisposition
        }, props.engagementId);
      }
    }, {
      key: "canSubscribe",
      value: function canSubscribe() {
        return this.context && this.context.subscribeEngagementState;
      }
    }, {
      key: "subscribeToStore",
      value: function subscribeToStore() {
        return this.context.subscribeEngagementState(this.onStoreChange);
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props4 = this.props,
          children = _this$props4.children,
          engagementId = _this$props4.engagementId;
        var message = this.state.message;
        if (!message) {
          if (componentType === 'inlineDialog') {
            return children || null;
          }
          return null;
        }
        if (engagementId && message !== null && message.target && engagementId !== message.target) {
          return null;
        }
        var messageKey = "".concat(message.messageId, ".").concat(message.variationId, ".").concat(message.componentId);

        // Key is useful here to make sure that when the currently active
        // messages changes, the old component is unmounted (therefore
        // firing an analytic event for hiding the component) and mounting
        // a new component for the new message (firing a shown event for
        // the new message). Not using key would allow React to apply an
        // optimization that would reuse the current component for a new
        // message which would not call the normal mount and unmount
        // lifecycle methods.
        return /*#__PURE__*/React.createElement(InnerComponent, _extends({
          key: messageKey
        }, this.props, message));
      }
    }]);
    return StoreWrapper;
  }(Component);
  _defineProperty(StoreWrapper, "contextTypes", {
    subscribeEngagementState: PropTypes.func,
    setComponentConfig: PropTypes.func
  });
  return StoreWrapper;
});